import { render, staticRenderFns } from "./ItemN_Details.vue?vue&type=template&id=58babaf8"
import script from "./ItemN_Details.vue?vue&type=script&lang=js"
export * from "./ItemN_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports